<template>
  <div class="history-bar">
    <div class="history-list">
      <div
        v-for="(item, i) in history"
        :key="i"
        class="history-item"
        :class="getColorClass(item)"
      >
        <img
          :src="getNumberImage(item)"
          :alt="item"
          class="history-img"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { io } from 'socket.io-client'

// 📦 Görseller
import img0 from '@/assets/img/wingo/0.png'
import img1 from '@/assets/img/wingo/1.png'
import img2 from '@/assets/img/wingo/2.png'
import img3 from '@/assets/img/wingo/3.png'
import img4 from '@/assets/img/wingo/4.png'
import img5 from '@/assets/img/wingo/5.png'
import img6 from '@/assets/img/wingo/6.png'
import img7 from '@/assets/img/wingo/7.png'
import img8 from '@/assets/img/wingo/8.png'
import img9 from '@/assets/img/wingo/9.png'

// 📡 Socket bağlantısı
const socketURL = process.env.VUE_APP_SOCKET_URL || 'https://play.rivobit.com'
const socket = io(socketURL, {
  transports: ['websocket'],
  withCredentials: true
})

// 📜 Oyun geçmişi
const history = ref([])

// 🧩 Sayı-görsel eşlemesi
const numberImages = {
  0: img0, 1: img1, 2: img2, 3: img3, 4: img4,
  5: img5, 6: img6, 7: img7, 8: img8, 9: img9
}

// 🔧 Güvenli görsel alma
const getNumberImage = (num) => {
  const parsed = parseInt(num, 10)
  return numberImages.hasOwnProperty(parsed) ? numberImages[parsed] : ''
}

// 🎨 Renk sınıfı
const getColorClass = (val) => {
  const parsed = parseInt(val, 10)
  if ([0, 5, 8].includes(parsed)) return 'violet'
  return parsed % 2 === 0 ? 'green' : 'red'
}

onMounted(() => {
  socket.emit('wingo:history:request')

  socket.on('wingo:history:response', (data) => {
    history.value = data
      .map(n => parseInt(n, 10))
      .filter(n => !isNaN(n) && n >= 0 && n <= 9)
  })

  socket.on('wingo:history:error', (err) => {
    console.error('History error:', err)
  })

  socket.on('wingo:round:result', ({ result }) => {
    const number = parseInt(result.number, 10)
    if (!isNaN(number) && number >= 0 && number <= 9) {
      if (history.value.length >= 20) history.value.pop()
      history.value.unshift(number)
    } else {
      console.warn('❌ Geçersiz sonuç numarası:', result.number)
    }
  })
})

onUnmounted(() => {
  socket.off('wingo:history:response')
  socket.off('wingo:history:error')
  socket.off('wingo:round:result')
})
</script>



<style scoped>
.history-bar::-webkit-scrollbar {
  display: none;
}
.history-bar {
  -ms-overflow-style: none;  /* IE/Edge */
  scrollbar-width: none;     /* Firefox */
}
.history-bar {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

.history-list {
  display: flex;
  flex-wrap: nowrap; /* ❗ ALT SATIRA GEÇMESİN */
  gap: 0.4rem;
  padding: 4px 0;
}

.history-item {
  flex-shrink: 0; /* ❗ Boyut küçülmesin */
  width: 33px;
  height: 33px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border-radius: 4px;
}

.history-img {
  width: 33px;
  height: auto;
  pointer-events: none;
  user-select: none;
}

</style>
